const styles = () => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    padding: "5px 16px 8px 16px",
    marginTop: 0,
    width: "100%",
    boxSizing: "border-box" as const,
    "& hr": {
      width: "100%",
      border: "none",
      borderTop: "1px solid #ccc",
      margin: "0 0 5px 0",
    },
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 0,
    lineHeight: 1.2,
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  text: {
    fontSize: "0.75rem",
  },
});

export default styles;
